import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import config from '../../../config';

import { createImageVariantConfig } from '../../../util/sdkLoader';
import { ListingCard, NamedLink } from '../../../components';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import css from './SectionLatestArrivals.module.css';

import './swiper.css';

const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

const SectionLatestArrivals = props => {
  const {
    rootClassName,
    className
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const [spotLightListings, setSpotlightListings] = useState([]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      require('swiper/css');
      require('swiper/css/bundle');
      require('swiper/css/navigation');
    }

    const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'listing-card' } = config.listing;
    const aspectRatio = aspectHeight / aspectWidth;
    sdk.listings
      .query({
        pub_rotatePendingApproval: false,
        include: ['author', 'images', 'author.profileImage', 'profileImage', 'currentStock'],
        'fields.listing': ['title', 'geolocation', 'price', 'publicData', 'description'],
        'fields.user': [
          'profile.displayName',
          'profile.abbreviatedName',
          'profile.publicData',
          'profileImage',
          'profile.profileImage',
        ],
        'fields.image': ['variants.listing-card', 'variants.listing-card-2x'],
        ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      })
      .then(res => {
        const listings = res.data.data;

        const images =
          res.data.included &&
          res.data.included.filter(i => {
            return i.type === 'image';
          });

        const users =
          res.data.included &&
          res.data.included.filter(i => {
            return i.type === 'user';
          });

        const stocks =
          res.data.included &&
          res.data.included.filter(i => {
            return i.type === 'stock';
          });

        if (users && users.length > 0) {
          users.forEach(u => {
            const imageId = u.relationships.profileImage.data?.id.uuid;

            const luckyImage = images.find(i => {
              return i.id.uuid === imageId;
            });

            u.profileImage = luckyImage;
          });
        }

        if (listings && listings.length > 0) {
          listings.forEach(l => {
            const imageId = l.attributes.publicData.selectedHeroImageId ||
              l.relationships.images.data[0]?.id.uuid;
            const authorId = l.relationships.author.data?.id.uuid;
            const stockId = l.relationships.currentStock.data?.id.uuid;

            const luckyImage = images.find(i => {
              return i?.id.uuid === imageId;
            });

            const author = users.find(u => {
              return u?.id.uuid === authorId;
            });

            const stock = stocks.find(s => {
              return s?.id.uuid === stockId;
            });

            l.author = author;
            l.images = [luckyImage];
            l.currentStock = stock;
          });
        }

        const listingsLeftToPush = 12 - listings.length;
        let finalListings = [...listings];

        for (let i = 1; i <= listingsLeftToPush; i++) {
          finalListings.push(listings[getRandomInt(listings.length - 1)]);
        }

        const finalListingsFiltered = finalListings.filter(l => l && l.attributes);
        setSpotlightListings(finalListingsFiltered);
      })
      .catch(e => console.log(e));
  }, []);

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  const slidesToShow = screenWidth && screenWidth < 768 ? 2.3 : 4;

  if (typeof window === 'undefined' || !spotLightListings || spotLightListings.length === 0) {
    return null;
  }

  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  return (
    <div className={classes}>
      <center>
        <h2 className={css.titleContainer}>
          <NamedLink name="SearchPage" className={css.title}>
            LATEST ARRIVALS
          </NamedLink>
        </h2>
      </center>
      <div className={css.wrapper}>
        <div className="custom_prev">
          <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
        </div>
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: '.custom_next',
            prevEl: '.custom_prev',
          }}
          style={{ paddingTop: '10px' }}
          spaceBetween={40}
          slidesPerView={slidesToShow}
        >
          {spotLightListings.map(l => {
            return (
              <SwiperSlide
                key={l.id.uuid}
              >
                <ListingCard
                  className={css.listingCard}
                  outOfStockClassName={css.outOfStockImage}
                  listing={l}
                  listingExpanded={l}
                  renderSizes={cardRenderSizes}
                  smallFavButton={true}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>

        <div className="custom_next">
          <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
        </div>
      </div>
    </div>
  );
};

export default SectionLatestArrivals;
